import React, { useContext } from 'react';
import { BasePage, Helmet, StaticContext } from '@sm/webassets';
import { t, defineMessages } from '@sm/intl';

import theme from '../../styles/SurveyMonkey.theme';

import BrandedSurveyTaken from './BrandedSurveyTaken';
import EUBrandedSurveyTaken from './EUBrandedSurveyTaken';
import NonBrandedSurveyTaken from './NonBrandedSurveyTaken';

const COPY = defineMessages({
  DEFAULT_TAKEN_MESSAGE: {
    id: 'SurveyTaken.takenMessage',
    defaultMessage: 'You have already taken this survey.',
  },
  META_KEYWORDS: {
    id: 'SurveyTaken.metaKeywords',
    defaultMessage:
      'questionnaire, questionnaires, questionaire, questionaires, free online survey, free online surveys',
  },
  TAKEN_PAGE_TITLE: {
    id: 'SurveyTaken.title',
    defaultMessage: 'Free Online Survey Software by SurveyMonkey: Survey Taken',
  },
  TAKEN_PAGE_NON_BRANDED_TITLE: {
    id: 'SurveyTaken.nonBrandedTitle',
    defaultMessage: 'Online Survey Software: Survey Taken',
  },
});

const SurveyTaken = () => {
  const {
    pageOptions: { canonical, isNonBranded = false },
    locale,
  } = useContext(StaticContext);

  const showFooter = !isNonBranded;

  return (
    <BasePage includeHeader={false} includeFooter={showFooter} pageId="Survey Taken" legacyWeb="anonweb" theme={theme}>
      <Helmet>
        <base target="_top" href="/" />
        <meta name="keywords" content={t(COPY.META_KEYWORDS)} />
        <meta name="description" content={t(COPY.DEFAULT_TAKEN_MESSAGE)} />
        <link rel="canonical" href={canonical} />
      </Helmet>
      <Choose>
        <When condition={isNonBranded}>
          <Helmet>
            <title>{t(COPY.TAKEN_PAGE_NON_BRANDED_TITLE)}</title>
          </Helmet>
          <NonBrandedSurveyTaken />
        </When>
        <When condition={locale.isEUSubdomain}>
          <Helmet>
            <title>{t(COPY.TAKEN_PAGE_NON_BRANDED_TITLE)}</title>
          </Helmet>
          <EUBrandedSurveyTaken />
        </When>
        <Otherwise>
          <Helmet>
            <title>{t(COPY.TAKEN_PAGE_TITLE)}</title>
          </Helmet>
          <BrandedSurveyTaken />
        </Otherwise>
      </Choose>
    </BasePage>
  );
};

export default SurveyTaken;
